import { helpers, maxLength as maxLengthValidator, minLength as minLengthValidator } from '@vuelidate/validators'

import { getValidators } from '@/shared/lib'

export const useBaseValidators = (minLength: number, maxLength: number) => {
  const { required } = getValidators()
  return {
    required,
    minLength: helpers.withMessage('base_min_length_chars', minLengthValidator(minLength)),
    maxLength: helpers.withMessage('base_max_length_chars', maxLengthValidator(maxLength)),
  }
}
